import ReelsToBuy, { MediaItem } from "@/components/ReelsToBuy";
import { useSEO } from "@/hooks/useSEO";
import { useEffect } from "react";
import { BRAND_SITE_URL } from "@/lib/brandConfig";

/**
 * Pack1 Page - Example pack with mixed content (images and videos)
 *
 * Features:
 * - Shows first 3 items for free (preview)
 * - After 3 items, shows purchase screen
 * - Mix of images and videos
 */
const Pack1 = () => {
  // SEO configuration
  useSEO({
    title: "Pack Premium #1 - Contenido Exclusivo",
    description: "Accede a contenido exclusivo premium",
    keywords: "pack, premium, exclusivo",
    ogImage: `${BRAND_SITE_URL}/og-pack1.jpg`,
    ogTitle: "Pack Premium #1",
    ogDescription: "Contenido exclusivo premium",
    type: "website",
    robots: "noindex, nofollow", // Don't index pack pages
  });

  // Disable body scroll when on pack page
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalWidth = document.body.style.width;
    const originalHeight = document.body.style.height;
    const originalTouchAction = document.body.style.touchAction;

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.height = "100%";
    document.body.style.touchAction = "none";

    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.width = originalWidth;
      document.body.style.height = originalHeight;
      document.body.style.touchAction = originalTouchAction;
      document.documentElement.style.overflow = "";
    };
  }, []);

  // Define your pack content here
  // Mix of images and videos - first 3 will be shown as preview
  const packItems: MediaItem[] = [
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&q=80",
      alt: "Preview 1",
    },
    {
      type: "video",
      src: "YOUR_MUX_PLAYBACK_ID_1", // Replace with actual Mux playback ID
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=800&q=80",
      alt: "Preview 2",
    },
    // More items (will be locked behind purchase)
    {
      type: "video",
      src: "YOUR_MUX_PLAYBACK_ID_2",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=800&q=80",
      alt: "Exclusive 1",
    },
    {
      type: "video",
      src: "YOUR_MUX_PLAYBACK_ID_3",
    },
  ];

  const handlePurchase = () => {
    if (import.meta.env.DEV) {
      console.log("Purchase clicked for Pack1");
    }
    // Add your purchase logic here (e.g., redirect to payment page, open modal, etc.)
  };

  return (
    <ReelsToBuy
      items={packItems}
      maxFreeItems={3}
      price="$9.99"
      packName="Pack Premium #1"
      purchaseUrl="/checkout/pack1" // Or use onPurchaseClick callback
      onPurchaseClick={handlePurchase}
    />
  );
};

export default Pack1;
